<style>
.no-more-data {
	display: flex;
	justify-content: center;
	align-items: center;
	color: #CCC;
	text-align: center;
	font-size: .26rem;
	line-height: 1rem;
}

.no-more-data::before, .no-more-data::after {
	content: "";
	width: 1rem;
	height: 1px;
	margin: 0 .24rem;
	background-color: #EEE;
}
</style>

<template>
	<p class="no-more-data" v-if="noMoreData">没有更多了~</p>
</template>

<script>
	export default {
		props: ["noMoreData"]
	}
</script>


// WEBPACK FOOTER //
// src/components/no-more-data.vue